/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { EitherAsync, Right } from 'purify-ts';
import * as itertools from './itertools';
import { RegisterArray } from './register_array';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Signal {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(name) {
        this.name = name;
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        this.arr = new RegisterArray();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    register(callback) {
        return this.arr.add(callback);
    }
    /**
     * Same as `send` but provides you with information about failing handlers.
     *
     * @param args The arguments to send.
     * @returns A promise with information about handler status.
     */
    sendWithErrors(...args) {
        return Promise.allSettled(itertools.map(this.arr, async (listener) => {
            try {
                await listener(...args);
            }
            catch (err) {
                // eslint-disable-next-line no-console
                console.error(new Error(`Listener ${listener.toString()} failed`));
                throw err;
            }
        }));
    }
    /**
     * Send the given arguments to the listeners of this signal.
     *
     * @param args The arguments to send.
     * @returns An EitherAsync that does the sending, ingoring any errors from handlers.
     */
    send(...args) {
        return EitherAsync.fromPromise(async () => {
            await this.sendWithErrors(...args);
            return Right(undefined);
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    sendLazy(getArgs) {
        if (this.arr.size === 0) {
            return EitherAsync(async () => { });
        }
        return getArgs().chain(args => this.send(...args));
    }
}
